'use strict';

var define = require('define-properties');
var callBind = require('call-bind');

var implementation = require('./implementation');
var getPolyfill = require('./polyfill');
var shim = require('./shim');

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;



/*****************
 ** WEBPACK FOOTER
 ** ./~/regexp.prototype.flags/index.js
 ** module id = 3819
 ** module chunks = 0
 **/